import { createRouter, createWebHistory } from 'vue-router';
import Empty from '../components/Empty.vue';
import { loadUserSettings, resetTableStateEvents, store } from '../store'; 
import EventsContainer from '../components/EventsContainer.vue';
import CrispService from '../services/crisp';
import SubscriptionsTable from '../components/SubscriptionsTable.vue';

const routes = [
  { path: '/', component: EventsContainer, props: true, beforeEnter: [handleEnter] },
  { path: '/callback/google-oauth', component: Empty, beforeEnter: [handleEnter, handleGoogleOAuthRedirect] },
  { path: '/verify-magic-link', component: Empty, beforeEnter: [handleEnter, handleMagicLink] },
  { path: '/l/:listId', component: EventsContainer, props: false, beforeEnter: [handleEnter, beforeListId] },
  { path: '/oauth', component: Empty, beforeEnter: [handleEnter, handleGoogleOAuth] },
  // { path: '/:marketName(polymarket|kalshi)/:marketSlug', component: EventsContainer, props: true, beforeEnter: [handleEnter] },
  // { path: '/subscriptions', component: SubscriptionsTable, beforeEnter: [handleEnter] },
  { path: '/:pathMatch(.*)*', component: Empty, beforeEnter: [redirectToRoot] }, // Redirect all unmatched routes to '/'
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

function redirectToRoot(to, from, next) {
  store.currentWatchList = {};
  store.currentWatchListId = null;
  next('/');
}

function beforeListId(to, from, next) {
  // Weird 'TypeError: Cannot read properties of undefined (reading 'query')' was resolved by
  // adding a console.log here
  // if (!store.isAuthenticated) {
  //   console.log('Not authenticated, redirecting to root');
  //   next('/');
  // }
  // else {
  //   next();
  // }
  
  next();
}

function handleEnter(to, from, next) {
  resetTableStateEvents();
  store.currentWatchList = {};
  store.currentWatchListId = null;

  if ('verifyLicenseKey' in to.query) {
    store.verifyLicenseKeyModal = true;
  }

  next();
}

// this is noop, fix
function handleGoogleOAuth(to, from, next) {
  console.warn('handleGoogleOAuth');
  const currentUrl = window.location.href;
  const oauthUrl = `https://api.nevua.markets/auth/oauth?state=${encodeURIComponent(currentUrl)}`;
  console.log(`Redirecting to: ${oauthUrl}`);
  //window.location.href = oauthUrl;
}

function handleGoogleOAuthRedirect(to, from, next) {
  const code = to.query.code;
  const state = to.query.state || '/';

  if (code) {
    fetch(`https://api.nevua.markets/auth/callback/google-oauth?code=${code}&state=${state}`)
      .then(response => response.json())
      .then(async (data) => {
        // Handle the response data, e.g., save token, redirect, etc.
        localStorage.setItem('jwtToken', data.token);

        await loadUserSettings(data.token);
        CrispService.client.user.setEmail(store.email);
        store.isLoggedIn = true;
        
        next(state);
      })
      .catch(error => {
        console.error('Error during OAuth:', error);
        next(state);
      });
  } else {
    next(state);
  }
}

async function handleMagicLink(to, from, next) {
  const nonce = to.query.nonce;
  
  if (!nonce) {
    next('/');
    return;
  }

  try {
    const response = await fetch(`https://api.nevua.markets/auth/verify-magic-link?nonce=${nonce}`);
    const data = await response.json();
    
    if (response.ok) {
      localStorage.setItem('jwtToken', data.token);
      await loadUserSettings(data.token);
      CrispService.client.user.setEmail(store.email);
      store.isLoggedIn = true;
    } else {
      throw new Error('Failed to verify login link');
    }
  } catch (error) {
      store.failedToVerifyLoginLink = true;
  }
  
  next('/');
}

export default router; 